import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import theme from './theme'

import NavBar from './components/navbar2'
import MainContainer from './components/MainContainer.jsx'


function App() {
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
            <NavBar />
            <MainContainer />
      </CssBaseline>
    </ThemeProvider>
 
  );
}

export default App;
